import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";

import Marcas1 from "../../static/media/home/marcas1.webp";
import Marcas2 from "../../static/media/home/marcas2.webp";
import Marcas3 from "../../static/media/home/marcas3.webp";
import Marcas4 from "../../static/media/home/marcas4.webp";
import Marcas5 from "../../static/media/home/marcas5.webp";

const C = {
  darkBlue: "#0C1F2F",
  navy: "#0057A8",
  cream: "#F8F6F0",
  creamDark: "#E6E2D6",
  white: "#ffffff",
  gold: "#FFCD00",
};

const ROW_1 = [Marcas1, Marcas3, Marcas5];
const ROW_2 = [Marcas2, Marcas4];

function MarqueeRow({ images, duration, reverse = false }) {
  const track = [...images, ...images, ...images];
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
        py: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "max-content",
          gap: { xs: "20px", md: "32px" },
          animation: `${reverse ? "marquee-reverse" : "marquee"} ${duration}s linear infinite`,
          "&:hover": { animationPlayState: "paused" },
          "@keyframes marquee": {
            "0%": { transform: "translateX(0)" },
            "100%": { transform: "translateX(-33.3333%)" },
          },
          "@keyframes marquee-reverse": {
            "0%": { transform: "translateX(-33.3333%)" },
            "100%": { transform: "translateX(0)" },
          },
        }}
      >
        {track.map((src, i) => (
          <Box
            key={i}
            sx={{
              flexShrink: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: C.white,
              borderRadius: "16px",
              px: { xs: "28px", md: "40px" },
              py: { xs: "20px", md: "24px" },
              boxShadow: "0 4px 12px rgba(12, 31, 47, 0.05)",
              border: `1px solid ${C.creamDark}`,
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              cursor: "pointer",
              "&:hover": {
                transform: "translateY(-4px) scale(1.02)",
                boxShadow: "0 12px 28px rgba(12, 31, 47, 0.12)",
                borderColor: "rgba(12, 31, 47, 0.1)",
              },
            }}
          >
            <Box
              component="img"
              src={src}
              alt="Marca Aliada"
              sx={{
                height: { xs: "40px", sm: "50px", md: "64px" },
                width: "auto",
                objectFit: "contain",
                display: "block",
                filter: "grayscale(10%)",
                transition: "filter 0.3s ease",
                "&:hover": {
                  filter: "grayscale(0%)",
                },
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default function Aliados() {
  return (
    <Box
      id="aliados"
      sx={{
        background: C.white, // Modificado a blanco puro para fusión perfecta con la ola anterior
        pt: { xs: "64px", md: "88px" },
        pb: { xs: "64px", md: "88px" },
        position: "relative",
        // Borde superior eliminado para evitar una línea de corte
      }}
    >
      <Box
        sx={{
          maxWidth: "1280px",
          mx: "auto",
          width: "100%",
          px: { xs: "24px", sm: "40px", md: "56px" },
          boxSizing: "border-box",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.6 }}
          sx={{ textAlign: "center", mb: { xs: 6, md: 8 } }}
        >
          <Typography
            variant="h2"
            sx={{
              color: C.darkBlue,
              fontWeight: 750,
              fontSize: { xs: 28, sm: 34, md: 40 },
              letterSpacing: "-.02em",
              lineHeight: 1.1,
              mb: 2,
            }}
          >
            Nuestros Aliados Estratégicos
          </Typography>
          <Box
            sx={{
              width: "45px",
              height: "3px",
              background: C.navy,
              mx: "auto",
              borderRadius: "2px",
              mb: 3,
            }}
          />
          <Typography
            sx={{
              color: "#5c6c7a",
              fontSize: { xs: 14, md: 16 },
              maxWidth: 700,
              mx: "auto",
              lineHeight: 1.6,
              fontWeight: 500,
            }}
          >
            Distribuimos marcas líderes a nivel mundial en material eléctrico,
            herramientas e iluminación, respaldando sus proyectos con garantía y
            soporte directo de fábrica.
          </Typography>
        </Box>

        <Box
          component={motion.div}
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: "20px", md: "28px" },
          }}
        >
          <MarqueeRow images={ROW_1} duration={35} />
          <MarqueeRow images={ROW_2} duration={30} reverse />
        </Box>
      </Box>
    </Box>
  );
}
